import {createContext} from "react";

function noop () {}

export const AuthContext = createContext({
    token: null,
    userId: null,
    userName: null,
    login: noop,
    logout: noop,
    saveFilialName: noop,
    isAuthenticated: false,
    ready: false,
    empId: null,
    empFilial: null,
    filialName: null,
    empInn: null
});